import React from "react";
import { Link } from "react-router-dom";
import { prefetchLocationItems } from "../../utils/locationsData";
import { getCountryColorVar } from "../../utils/countryColors";

/**
 * Accessible, canonical country list. This is the fallback/keyboard navigation surface for the
 * Locations hub; the map (LocationsMap) is a visual enhancement layered on top, never the only
 * way to reach a country (locations-browser.md §4, §7). Each chip's dot matches its map color.
 * Rows are already sorted by count (descending) by the backend.
 */
export function LocationsList({ locations, activeCode, colorMap, onHoverCode, onFocusCode }) {
  if (!locations.length) {
    return <p className="locations-empty">No locations with photos yet.</p>;
  }

  return (
    <nav aria-label="Locations" className="locations-list">
      <ul>
        {locations.map((loc) => (
          <li key={loc.countryCode}>
            <Link
              to={`/locations/${loc.countryCode}`}
              className={`locations-list-row ${
                activeCode === loc.countryCode ? "locations-list-row-active" : ""
              }`}
              onMouseEnter={() => {
                onHoverCode?.(loc.countryCode);
                prefetchLocationItems(loc.countryCode);
              }}
              onMouseLeave={() => onHoverCode?.(null)}
              onFocus={() => {
                onFocusCode?.(loc.countryCode);
                prefetchLocationItems(loc.countryCode);
              }}
              onBlur={() => onFocusCode?.(null)}
            >
              <span
                className="locations-list-dot"
                style={{ background: colorMap?.get(loc.countryCode) ?? getCountryColorVar(loc.countryCode) }}
                aria-hidden="true"
              />
              <span className="locations-list-name">{loc.name}</span>
              <span className="locations-list-count">
                {loc.count} photo{loc.count === 1 ? "" : "s"}
              </span>
            </Link>
          </li>
        ))}
      </ul>
    </nav>
  );
}
